import React, { PureComponent } from 'react';
import * as Sentry from '@sentry/browser';
import ErrorPage from '@olxeu-a2b/ui/src/commons/components/ErrorPage';
import { getConfig } from '@olxeu-a2b/delivery-utils/src/extras';
import { useI18n } from '@olxeu-a2b/ui/src/i18n';

const {
  mweb: { url },
} = getConfig('sites');

const ErrorBlock = ({ error }) => {
  const i18n = useI18n();

  if (!error.message) {
    return <ErrorPage status={error?.status?.toString()} homeUrl={url} />;
  }

  const { message } = error;
  const msgToDisplay = /dlv_.*/.test(message) ? i18n(message) : message;
  return <ErrorPage status={msgToDisplay} homeUrl={url} />;
};

export default class PageErrorBoundary extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    Sentry.captureException(error, info);
  }

  render() {
    const { children } = this.props;
    const { hasError, error } = this.state;

    if (hasError) {
      return <ErrorBlock error={error} />;
    }
    return children;
  }
}
